import React, { useEffect, useState } from "react";
import { apiCallResponse } from "src/_apiConfig/apiCall";

import Auth from "src/auth";
import { TableHeader } from "../common/Table/TableHeaderLabel";
import {
  CommonSearchExtra,
  SCInput,
  updateSearchStatus,
} from "../common/CommonSearch";
import { FilterContainsInsensitive } from "../common/FilterCondition";
import CommonList from "../common/CommonList";

const CgmfList = () => {
  const { authenticated } = Auth();
  const [usersData, setuserData] = useState([]); // List data manage
  const [pageCount, setPageCount] = useState(0); // List Data pagging manage
  const [loading, setloading] = useState(false); // page loading
  const [pageLimit, setpageLimit] = useState(0); // pageing index manage
  const [itemPerPage, setItemPerPage] = useState(10); // Record Show Each Page
  const [disabledprev, setdisabledprev] = useState(false); //Pagging Prev. Button disabled manage;
  const [disablednext, setdisablednext] = useState(false); //Pagging Next Button disabled manage;
  const [isSearch, setIsSearch] = useState(false); // Search Button Effect Manage
  // eslint-disable-next-line no-unused-vars
  const [isClear, setIsClear] = useState(false); // Clear Button Effect Manage
  const [textField, settextField] = useState("name"); // table header Default Selected Column
  const [order, setorder] = useState("asc"); // table header Default Selected Column order Set
  const [orderClick, setOrderClick] = useState(true); // table header orderClick Column manage

  // Your default search model
  const SearchFilterModel = {
    emailId: "",
    name: "",
    mobile: "",
    streetName: "",
  };

  const [search, setSearch] = useState(SearchFilterModel);

  // useEffect(() => {
  //   orderClick ? setorder("asc") : setorder("desc");
  //   getCgmflist(true);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [pageLimit, textField, orderClick, itemPerPage]);

  useEffect(() => {
    setloading(true);
    resetPageLimit(0);
    getPageCount();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);

  useEffect(() => {
    if (isSearch === false) {
      getCgmflist();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, pageLimit, textField, orderClick]);

  useEffect(() => {
    if (isSearch) {
      getPageCount();
      getCgmflist();
      setIsClear(false);
      setIsSearch(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSearch, itemPerPage]);

  const resetPageLimit = (pageLimit) => {
    setpageLimit(pageLimit || 0);
  };
  // pagging Disabled  manage
  const paggingDisabled = (isNext = true, isPrev = true) => {
    setdisablednext(isNext);
    setdisabledprev(isPrev);
  };
  // pagging Manage
  const paggingDisabledManage = (totalRecord) => {
    setPageCount(parseInt(totalRecord) || 0);
    paggingDisabled(
      pageLimit >= parseInt(totalRecord) - parseInt(itemPerPage),
      pageLimit === 0
    );
  };

  // Filter paramater Value manage for API
  const filterManage = () => {
    let filter = "";
    filter = "&$filter=";
    filter = FilterContainsInsensitive(filter, "emailId", search.emailId);
    filter = FilterContainsInsensitive(filter, "name", search.name);
    filter = FilterContainsInsensitive(filter, "mobile", search.mobile);
    filter = FilterContainsInsensitive(filter, "streetName", search.streetName);
    if (filter === "&$filter=") {
      filter = "";
    }

    return filter;
  };
  const getPageCount = async () => {
    if (authenticated) {
      await apiCallResponse(`User/getCGMFOfficers?${filterManage()}`).then(
        (res) => {
          if (res.success)
            paggingDisabledManage(parseInt(res.data.length) || 0);
        }
      );
    }
  };

  const getCgmflist = async (firstRequest) => {
    if (authenticated) {
      paggingDisabled();
      setloading(true);

      await apiCallResponse(
        `User/getCGMFOfficers?$orderBy=${textField}%20${order}&$skip=${pageLimit}&$top=${Number(
          itemPerPage
        )}${filterManage()}`
      ).then((res) => {
        if (res.success) {
          setuserData(res.data);
          if (isSearch === false && pageLimit >= 0 && pageCount > 0) {
            paggingDisabledManage(pageCount);
          }
        }
        setloading(false);
      });
    }
  };

  // Search Model Value Update Manage
  const updateSearch = (e, name = "", value = "") => {
    updateSearchStatus(setSearch, search, e, name, value);
  };
  // item per page  onChanage Event
  const onChangePage = (ev) => {
    ev.preventDefault();
    resetPageLimit();
    setItemPerPage(ev.target.value);
    setIsSearch(true);
  };

  // Search Button Click Event
  const searchButton = (ev) => {
    ev.preventDefault();
    resetPageLimit();
    setIsSearch(true);
  };
  // Clear Button Click Event
  const clearSearchButton = (ev) => {
    ev.preventDefault();
    resetPageLimit();
    setIsClear(true);
    setIsSearch(true);
    setSearch({ ...search, ...SearchFilterModel });
    setuserData();
  };

  // Pagging Prev. Button Click Event
  const prevButton = () => {
    let pageLimitSet = parseInt(pageLimit) - parseInt(itemPerPage);
    pageLimitSet = pageLimitSet < 0 ? 0 : pageLimitSet;
    resetPageLimit(pageLimitSet);
  };
  // Pagging Next Button Click Event
  const nextButton = () => {
    let pageLimitSet = parseInt(pageLimit) + parseInt(itemPerPage);
    pageLimitSet =
      pageLimitSet >= parseInt(pageCount) ? parseInt(pageCount) : pageLimitSet;
    resetPageLimit(pageLimitSet);
  };
  const searchControl = (
    <>
      <SCInput
        label="Email Address :"
        name={"emailId"}
        value={search.emailId}
        onChange={updateSearch}
      />
      <SCInput
        label="Officer Name :"
        name={"name"}
        value={search.name}
        onChange={updateSearch}
      />
      <SCInput
        label="Mobile No. :"
        name={"mobile"}
        value={search.mobile}
        onChange={updateSearch}
      />
      <SCInput
        label="Street Location :"
        name={"streetName"}
        value={search.streetName}
        onChange={updateSearch}
      />
    </>
  );
  const additional = (
    <CommonSearchExtra
      isDisabledSearchClear={loading}
      extraControl={searchControl}
      search={search}
      updateSearch={updateSearch}
      searchButton={searchButton}
      clearSearchButton={clearSearchButton}
      itemPerPage={itemPerPage}
      onChangePage={onChangePage}
    />
  );

  const thClick = (ev, getTextField) => {
    ev.preventDefault();
    setOrderClick(!orderClick);
    if (textField !== getTextField) {
      setorder("asc");
    } else {
      !orderClick ? setorder("asc") : setorder("desc");
    }
    resetPageLimit(0);
    settextField(getTextField);
  };
  //table Header Set
  const TableHeaderSet = (labelValue, getTextField) => {
    return TableHeader(labelValue, getTextField, thClick, textField, order);
  };
  const fields = [
    {
      key: "emailId",
      label: TableHeaderSet("Email Address", "emailId"),
    },
    {
      key: "name",
      label: TableHeaderSet("Name", "name"),
    },
    {
      key: "mobile",
      label: TableHeaderSet("Mobile No", "mobile"),
    },
    {
      key: "District",
      label: TableHeaderSet("District Union", "disctrict"),
    },
    {
      key: "Street",
      label: TableHeaderSet("Street Location", "streetName"),
    },
  ];
  return (
    <CommonList
      items={usersData}
      fields={fields}
      listName="CGMFP Federation officer Search"
      loading={loading}
      path="/cgmflist"
      additional={additional}
      prev={prevButton}
      next={nextButton}
      disabledprev={disabledprev}
      disablednext={disablednext}
    />
  );
};

export default CgmfList;
